import React, { useState, useEffect } from 'react';
import AnimatedWord from './animations/AnimatedWord';

function HeroSection({ featuresRef }) {
  const subHeadingWords = ['All-in-One ', 'Student ', 'Management ', 'System '];
  const mainHeadingWords = ['School', 'Line'];
  const tagLineWords = ['Empowering ', 'schools ', 'with ', 'smarter ', 'solutions ', 'for ', 'student ', 'management.'];
    // State to track animation completion
    const [isAnimationComplete, setAnimationComplete] = useState(false);
    const btnAnimationDuration = 1000;
    const btnAnimationDelay = 1000;


    // Set animation complete after delay
    useEffect(() => {
      const timer = setTimeout(() => {
        setAnimationComplete(true);
      },btnAnimationDuration + btnAnimationDelay);
  
      return () => clearTimeout(timer); // Cleanup on component unmount
    }, []);


      // Scroll handler
  const handleScrollToChatBox = () => {
    console.log(`scrolling to features ref ${featuresRef.current}`);
    if (featuresRef.current) {
      featuresRef.current.scrollIntoView({ behavior: 'smooth', block: 'end' });
    }
  };


  return (
    <section className="relative bg-gradient-to-r from-primaryColorLight to-primaryColor h-screen flex items-center justify-center">
      {/* Overlay for better text readability */}
      <div className="absolute inset-0 bg-black bg-opacity-50 z-10"></div>

      {/* Content */}
      <div className="relative text-center text-white z-20 max-w-3xl px-6">
        {/* Main Heading */}
        <h1 className="text-5xl md:text-6xl font-extrabold drop-shadow-lg mb-0 bg-gradient-to-r from-yellow-400 to-orange-600 bg-clip-text animate-fade-in">
  {mainHeadingWords.map((word, index) => (
    <AnimatedWord key={index} word={word} minimumDelay={0.1} index={index} />
  ))}
</h1>

        {/* Subheading */}
        <p className="text-lg md:text-xl font-light drop-shadow-md mb-8">
          {subHeadingWords.map((word, index) => (
            <AnimatedWord key={index} word={word} minimumDelay={0.5} index={index} />
          ))}
        </p>

        {/* Call-to-Action Button */}
        <button
  className={`px-6 py-3 bg-accentColor rounded-lg shadow-xl transition-transform duration-700 
    animate-slide-fade-in hover:shadow-2xl hover:scale-105 ${isAnimationComplete?'opacity-100':'opacity-0'} `}
  style={{
    animationDelay: `${btnAnimationDelay}ms`, // Delay before animation starts
    animationDuration: `${btnAnimationDuration}ms`,
  }}

  onClick={handleScrollToChatBox}
>
  Explore Features
</button>

        {/* Tagline */}
        <p className="text-sm md:text-base text-accentColor-light drop-shadow-md mt-6 bg-black bg-opacity-10 px-2 py-1 rounded">
          {tagLineWords.map((word, index) => (
            <AnimatedWord key={index} word={word} minimumDelay={1.5} index={index} />
          ))}
</p>
      </div>

      {/* Background Illustration */}
      <div className="absolute inset-0 w-full h-full z-0">
        <img
          src="assets/testimonials/illustration.webp"
          alt="Student studying"
          className="w-full h-full object-cover object-center animate-float"
        />
      </div>

      {/* Scroll Indicator */}
      <div className="absolute bottom-4 text-white animate-bounce z-30"
      onClick={handleScrollToChatBox}>
        <span>Scroll for more ↓</span>
      </div>

      {/* Animated Shapes */}
      <div className="absolute top-10 left-10 w-16 h-16 bg-accentColor rounded-full animate-pulse"></div>
      <div className="absolute top-20 right-20 w-12 h-12 bg-primaryColor rounded-lg animate-bounce"></div>
    </section>
  );
}

export default HeroSection;